export const ASSISTANT_FIELDS_FRAGMENT = gql`
  fragment AssistantFields on Assistant {
    id
    workspaceId

    firstName
    lastName
    photoUrl
    title
    description
    defaultLanguage
    disc
    personalityNotes
    ownerId
    tierId
    instructions {
      toolId
      instructions
    }
    goals {
      id
      name
      description
      toolInstructions {
        toolId
        instructions
      }
    }
  }
`
